import { render, staticRenderFns } from "./SubmitCeremony.vue?vue&type=template&id=6d073a55&scoped=true"
import script from "./SubmitCeremony.vue?vue&type=script&lang=js"
export * from "./SubmitCeremony.vue?vue&type=script&lang=js"
import style0 from "./SubmitCeremony.vue?vue&type=style&index=0&id=6d073a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d073a55",
  null
  
)

export default component.exports